export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  sortBy: ['id'],
  sortDesc: [true],
})

export const defaultFiltersPlayer = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  sortBy: ['id'],
  sortDesc: [true],
  filter: {},
  cfFilter: {},
  clientOptions: {
    filterPanelExpanded: false,
  },
})
